import { render, staticRenderFns } from "./PercentageInput.vue?vue&type=template&id=a2971ad8&scoped=true&"
import script from "./PercentageInput.vue?vue&type=script&lang=js&"
export * from "./PercentageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2971ad8",
  null
  
)

export default component.exports